import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5556 6.6C17.2356 7.23 14.5156 7.5 12 7.5C9.48444 7.5 6.76444 7.23 4.44444 6.6L4 8.4C5.65333 8.85 7.55556 9.147 9.33333 9.3V21H11.1111V15.6H12.8889V21H14.6667V9.3C16.4444 9.147 18.3467 8.85 20 8.4L19.5556 6.6ZM12 6.6C12.9778 6.6 13.7778 5.79 13.7778 4.8C13.7778 3.81 12.9778 3 12 3C11.0222 3 10.2222 3.81 10.2222 4.8C10.2222 5.79 11.0222 6.6 12 6.6Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }